import { FC, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MaskedInput from 'react-text-mask';
// @ts-ignore
import { NotificationManager } from 'react-notifications';

import { RootState } from 'types';
import { dispatch } from 'store';
import { setNotification } from 'modules/app/actions';
import {
  getMachines,
  activateMachine,
  deactivateMachine,
  getDashboardInfo,
  renameMachine,
} from 'modules/dashboard/actions';

import { Button, Container, HeaderSecond } from 'views/components';

import styles from './License.module.css';
import { Link } from 'react-router-dom';
import { routes } from 'routes';
import { clearError, deleteSubscription, showCancelPopup } from 'modules/subscription/actions';

import edit from 'assets/images/edit.png';

import { t } from 'utils';

import texts from './texts';

const mask = [
  /[[a-z0-9A-Z]/,
  /[[a-z0-9A-Z]/,
  '-',
  /[[a-z0-9A-Z]/,
  /[[a-z0-9A-Z]/,
  '-',
  /[[a-z0-9A-Z]/,
  /[[a-z0-9A-Z]/,
  '-',
  /[[a-z0-9A-Z]/,
  /[[a-z0-9A-Z]/,
  '-',
  /[[a-z0-9A-Z]/,
  /[[a-z0-9A-Z]/,
  '-',
  /[[a-z0-9A-Z]/,
  /[[a-z0-9A-Z]/,
  '-',
  /[[a-z0-9A-Z]/,
  /[[a-z0-9A-Z]/,
  '-',
  /[[a-z0-9A-Z]/,
  /[[a-z0-9A-Z]/,
];

export const License: FC = () => {
  // store
  const { machines, account_info, errors, plan } = useSelector(
    (state: RootState) => state.dashboard,
  );
  const { notification } = useSelector((state: RootState) => state.app);
  const { errors: errorsSubscription, loading, isCancelPopup } = useSelector((state: RootState) => state.subscription);

  const [valueInput, setValueInput] = useState<any>({});

  let ownerPlan = machines.find((o: { owner: null }) => o.owner !== null);
  const enterprisePlan = plan.price === 'Enterprise';

  const invalidComputerIds: any = [];

  for (let key in valueInput) {
    if (valueInput[key].indexOf('_') !== -1) {
      invalidComputerIds.push(+key);
    }
  }

  useEffect(() => {
    dispatch(getMachines.request());
    dispatch(getDashboardInfo.request());
    dispatch(clearError());
  }, []);

  useEffect(() => {
    if (notification.status && notification.type === 'success') {
      NotificationManager.success(notification.text);
      dispatch(setNotification(false));
    }
  }, [notification]);

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    setValueInput({
      ...valueInput,
      [name]: value,
    });
  };

  const activateMachineHandler = useCallback(
    (id, machineId) => {
      dispatch(activateMachine.request(id, machineId));
    },
    [dispatch],
  );

  const renderError = () => {
    if (errorsSubscription?.server) {
      return <p style={{ color: 'red', fontSize: '12px' }}>{errorsSubscription?.server}</p>;
    } else {
      for (let key in errors) {
        return <p style={{ color: 'red', fontSize: '12px' }}>{errors[key]}</p>;
      }
    }
  };

  const unsubscribe = useCallback(() => {
      dispatch(deleteSubscription.request());
  }, []);

  const editMachineNameHandler = useCallback(
    (id: number) => {
      // @ts-ignore
      const result = prompt(t(texts.licence.newNname));
      console.log(
        'texts.licence: ',
        t(texts.licence.minCharacters),
        t(texts.licence.maxCharacters),
      );
      if (result) {
        if (result.length > 32) {
          alert(t(texts.licence.maxCharacters));
        } else {
          dispatch(renameMachine.request(id, result));
        }
      } else {
        alert(t(texts.licence.minCharacters));
      }
    },
    [dispatch, t],
  );

  return (
    <Container>
      <HeaderSecond />
      <div className={styles.container}>
        <p style={{ fontSize: '26px', color: '#161721', textTransform: 'capitalize' }}>
          {t(texts.licence.hi)}, {account_info.full_name}
        </p>
        <Link className={styles.link} to="/dashboard">
          {t(texts.licence.backToDashboard)}
        </Link>
        {renderError()}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '10px',
            marginTop: '50px',
          }}
        >
          <p style={{ fontWeight: 'bold' }}>{t(texts.licence.yourLicenceSummary)}</p>
          {plan.is_active && (
            <div>
              <button 
              onClick={() => dispatch(showCancelPopup(true))} 
              className={styles.deleteButton}
              disabled={loading}
              >
                {t(texts.licence.cancelPlan)}
              </button>
            </div>
          )}
        </div>
        <div className={styles.mainMobile}>
          {machines.length > 0 &&
            machines.map((el: any) => (
              <div className={styles.licenseBlock}>
                <div className={styles.licenseBlockTop}>
                  <div>
                    {ownerPlan ? (
                      <span
                        style={{
                          cursor: 'pointer',
                          padding: '5px 10px 5px 0',
                        }}
                      >
                        {el.owner.full_name && el.owner.full_name}{' '}
                        {el.owner.store_location && `(${el.owner.store_location})`}
                      </span>
                    ) : (
                      <span
                        style={{
                          cursor: 'pointer',
                          padding: '5px 10px 5px 0',
                        }}
                        onClick={() => editMachineNameHandler(el.id)}
                      >
                        {el.nickname}
                        <img
                          style={{ margin: '0 0 -2px 10px', width: '12px', height: '12px' }}
                          src={edit}
                        />
                      </span>
                    )}
                  </div>
                  <div>
                    {el.is_active ? (
                      <span
                        style={{
                          width: '10px',
                          height: '10px',
                          display: 'inline-block',
                          backgroundColor: 'green',
                          borderRadius: '10px',
                          marginRight: '5px',
                        }}
                      ></span>
                    ) : (
                      <span
                        style={{
                          width: '10px',
                          height: '10px',
                          display: 'inline-block',
                          backgroundColor: '#f6595f',
                          borderRadius: '10px',
                          marginRight: '5px',
                        }}
                      ></span>
                    )}
                    {el.is_active ? 'Active' : 'Inactive'}
                  </div>
                </div>
                <div className={styles.licenseBlockBottom}>
                  <div>
                    <p className={styles.label}>{t(texts.licence.computerID)}</p>
                    {el.machine_id ? (
                      <p style={{ fontSize: '14px' }}>{el.machine_id}</p>
                    ) : (
                      <MaskedInput
                        mask={mask}
                        placeholder="xx-xx-xx-xx-xx-xx-xx-xx"
                        style={{
                          minWidth: 210,
                          height: 40,
                          padding: '0 20px',
                          fontSize: '16px',
                        }}
                        name={el.id}
                        value={valueInput[el.id]}
                        onChange={e => handleInputChange(e)}
                      />
                    )}
                  </div>
                  <div>
                    <p className={styles.label}>{t(texts.licence.activationCode)}</p>
                    <p style={{ fontSize: '14px' }}>{el.activation_code || 'NA'}</p>
                  </div>
                  <div>
                    <p className={styles.label}>{t(texts.licence.validDate)}</p>
                    {el.is_active ? (
                      <p style={{ fontSize: '14px' }}>{`${el.expiry_date?.split('-')[2]}/${
                        el.expiry_date?.split('-')[1]
                      }/${el.expiry_date?.split('-')[0]}`}</p>
                    ) : (
                      'NA'
                    )}
                  </div>
                  <div style={{ marginTop: 20 }}>
                    {!el.machine_id ? (
                      <a
                        aria-disabled="true"
                        className={`
                        ${styles.link} 
                        ${(!valueInput[el.id] || invalidComputerIds.includes(el.id)) &&
                          styles.disabled} 
                        ${styles.bold}
                        `}
                        onClick={() => activateMachineHandler(el.id, valueInput[el.id])}
                      >
                        {t(texts.licence.activate)}
                      </a>
                    ) : (
                      <a
                        className={`${styles.link} ${styles.bold}`}
                        onClick={() => {
                          dispatch(deactivateMachine.request(el.id));
                        }}
                      >
                        {t(texts.licence.revoke)}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>

        <div className={styles.main}>
          <table width="100%">
            <thead>
              <tr>
                <td>{t(texts.licence.number)}</td>
                <td>{ownerPlan ? 'Full name' : t(texts.licence.nickname)}</td>
                {ownerPlan && <td>Store location</td>}
                <td>{t(texts.licence.computerID)}</td>
                <td>{t(texts.licence.activationCode)}</td>
                <td>{t(texts.licence.validDate)}</td>
                <td>{t(texts.licence.status)}</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {machines.length > 0 &&
                machines.map((el: any, index: number) => (
                  <tr key={el.id}>
                    <td>{index + 1}</td>
                    <td>
                      {ownerPlan ? (
                        <span
                          style={{
                            cursor: 'pointer',
                            padding: '5px 10px 5px 0',
                            wordBreak: 'break-all',
                          }}
                        >
                          {el.owner.full_name || '-'}
                        </span>
                      ) : (
                        <span
                          style={{
                            cursor: 'pointer',
                            padding: '5px 10px 5px 0',
                          }}
                          onClick={() => editMachineNameHandler(el.id)}
                        >
                          {el.nickname}
                          <img
                            style={{ margin: '0 0 -2px 10px', width: '12px', height: '12px' }}
                            src={edit}
                          />
                        </span>
                      )}
                    </td>
                    {ownerPlan && <td>{el.owner.store_location || <p>-</p>}</td>}
                    <td>
                      {el.machine_id || (
                        <MaskedInput
                          mask={mask}
                          placeholder="xx-xx-xx-xx-xx-xx-xx-xx"
                          style={{
                            width: 210,
                            height: 40,
                            padding: '0 20px',
                            fontSize: '16px',
                          }}
                          name={el.id}
                          value={valueInput[el.id]}
                          onChange={e => handleInputChange(e)}
                        />
                      )}
                    </td>
                    <td>{el.activation_code || 'NA'}</td>
                    <td>
                      {el.is_active
                        ? `${el.expiry_date?.split('-')[2]}/${el.expiry_date?.split('-')[1]}/${
                            el.expiry_date?.split('-')[0]
                          }`
                        : 'NA'}
                    </td>
                    <td>
                      {el.is_active ? (
                        <span
                          style={{
                            width: '10px',
                            height: '10px',
                            display: 'inline-block',
                            backgroundColor: 'green',
                            borderRadius: '10px',
                            marginRight: '5px',
                          }}
                        />
                      ) : (
                        <span
                          style={{
                            width: '10px',
                            height: '10px',
                            display: 'inline-block',
                            backgroundColor: '#f6595f',
                            borderRadius: '10px',
                            marginRight: '5px',
                          }}
                        />
                      )}
                      {el.is_active ? t(texts.licence.active) : t(texts.licence.inactive)}
                    </td>
                    <td>
                      {!el.machine_id ? (
                        <a
                          aria-disabled="true"
                          className={`${styles.link}
                          ${(!valueInput[el.id] || invalidComputerIds.includes(el.id)) &&
                            styles.disabled}  ${styles.bold}`}
                          onClick={() => activateMachineHandler(el.id, valueInput[el.id])}
                        >
                          {t(texts.licence.activate)}
                        </a>
                      ) : (
                        <a
                          className={`${styles.link} ${styles.bold}`}
                          onClick={() => {
                            dispatch(deactivateMachine.request(el.id));
                          }}
                        >
                          {t(texts.licence.revoke)}
                        </a>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        {!enterprisePlan && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: '20px',
            }}
          >
            <p>{t(texts.licence.needLicence)}?</p>
            <Link to={routes.plan} style={{ textDecoration: 'none', marginBottom: '50px' }}>
              <Button title={t(texts.licence.upgradePlan)} onClick={() => {}} />
            </Link>
          </div>
        )}
      </div>
      {isCancelPopup && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
          <p>{t(texts.licence.cancelPlanPopup)}</p>
          <div className={styles.modalbtn}>
            <button onClick={unsubscribe} style={{marginRight: '3px'}}>Yes</button>
            <button onClick={() => dispatch(showCancelPopup(false))}>No</button>
          </div>
          </div>
        </div>
      )}
    </Container>
  );
};
